import { render, staticRenderFns } from "./V2AppHeader.vue?vue&type=template&id=5fba2eec&scoped=true&"
import script from "./V2AppHeader.vue?vue&type=script&lang=js&"
export * from "./V2AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./V2AppHeader.vue?vue&type=style&index=0&id=5fba2eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba2eec",
  null
  
)

export default component.exports